import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "contactsNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" }
const _hoisted_6 = {
  class: "mb-5",
  id: "contactsForm"
}
const _hoisted_7 = {
  key: 0,
  class: "text-2xl font-semibold"
}
const _hoisted_8 = {
  key: 1,
  class: "text-2xl font-semibold"
}

import contactsNavigation from '@/components/SubNavigations/TheContactsNavigation.vue'
    import useContactStore from '@/utils/useContactStore'
    import contactsForm from '@/components/Contacts/ContactsForm.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContactsEdit',
  setup(__props) {

    const { selectedContact } = useContactStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(contactsNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_unref(selectedContact)?.contactId)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_7, " Kontakt bearbeiten "))
            : (_openBlock(), _createElementBlock("h2", _hoisted_8, "Neuen Kontakt erfassen")),
          _createVNode(contactsForm)
        ])
      ])
    ])
  ], 64))
}
}

})